import {cn} from 'src/app/helpers/index'
import {FC, HTMLAttributes} from 'react'

export interface DividerProps extends HTMLAttributes<HTMLDivElement> {}

export const Devider: FC<DividerProps> = ({...props}) => {
  return <div {...props} className={cn(props.className, 'my-5 border-b-2 border-dotted')}></div>
}
